import { helpers } 		from './sites/helpers.js';
import { example } 		from './sites/components/exapmple.js';

window.sites = {
	globals: {},

	init: function () {
		var self = this;

		example.init();
	},

	onresize() {
		var self = this;
	},

	onscroll(position, previusPosition) {
		var self = this;
	},
};

jQuery(document).ready(function ($) {
	sites.init();
});

window.addEventListener('scroll', function (e) {
	sites.onscroll();
});

window.addEventListener('resize', function (e) {
	sites.onresize();
});